<section class="p-2">
   <p-confirmDialog
      header="Confirmation"
      icon="pi pi-exclamation-triangle"></p-confirmDialog>
   <div
      class="spinner"
      *ngIf="isLoading">
      <div
         class="spinner-border"
         role="status">
         <span class="sr-only">Loading...</span>
      </div>
   </div>
   <div *ngIf="!isLoading">
      <div class="row mx-0 mb-2">
         <div
            class="col"
            style="display: flex; align-items: center">
            <p-checkbox
               name="groupname"
               [binary]="true"
               [disabled]="isLoading"
               label="Show Only Unmapped"
               [(ngModel)]="this.onlyUnmapped"
               (onChange)="onFilterShowOnlyUnmapped()"></p-checkbox>
         </div>
         <div class="col">
            <button
               [disabled]="saving"
               style="float: right"
               (click)="onSave()"
               class="btn btn-danger btn-lg">
               <ng-container *ngIf="saving"><span class="fa fa-spin fa-spinner"></span></ng-container>
               Save
            </button>
         </div>
      </div>
      <div class="viewport">
         <p-table
            #dt
            [loading]="isLoading"
            [showLoader]="true"
            [scrollable]="true"
            scrollHeight="flex"
            [virtualScroll]="true"
            [virtualRowHeight]="75"
            [value]="items"
            [rows]="200">
            <ng-template pTemplate="header">
               <tr>
                  <th pSortableColumn="practiceName">
                     <p-sortIcon field="practiceName"></p-sortIcon>
                     Practice Name
                  </th>
                  <th pSortableColumn="lastUsedDate">
                     <p-sortIcon field="lastUsedDate"></p-sortIcon>
                     Last Used Date
                  </th>
                  <th pSortableColumn="amount">
                     <p-sortIcon field="amount"></p-sortIcon>
                     Amount
                  </th>
                  <th pSortableColumn="paymentTypeGroup">
                     <p-sortIcon field="paymentTypeGroup"></p-sortIcon>
                     Payment Type Group
                  </th>
                  <th pSortableColumn="paymentTypeName">
                     <p-sortIcon field="paymentTypeName"></p-sortIcon>
                     Payment Type Name
                  </th>
               </tr>
            </ng-template>
            <ng-template
               pTemplate="body"
               let-item>
               <tr>
                  <td>{{ item.practiceName }}</td>
                  <td>{{ item.lastUsedDate | date }}</td>
                  <td>{{ item.amount | currency }}</td>
                  <td>{{ item.paymentTypeName }}</td>
                  <td>
                     <p-select
                        [disabled]="saving"
                        appendTo="body"
                        [options]="groupOptions"
                        placeholder="Select"
                        styleClass="p-column-filter"
                        [(ngModel)]="item.mapGroup"
                        (onChange)="onItemChange(item)"></p-select>
                  </td>
               </tr>
            </ng-template>
         </p-table>
      </div>
   </div>
</section>
